import { Component, OnInit } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { GetEmpty } from 'src/app/classes/Empties';
import { Address, Store, User, User_Permission } from 'src/app/models/RestModels';
import { BaseComponent } from '../base/base.component';

@Component({
	selector: 'app-save-provider',
	templateUrl: './save-provider.component.html',
	styleUrls: ['./save-provider.component.css']
})
export class SaveProviderComponent extends BaseComponent implements OnInit
{
	user:Partial<User>	= {};
	user_permission:User_Permission = GetEmpty.user_permission();
	store_list:Store[] = [];
	password_type:'text'|'password' = 'password';
	address:Address = this.getEmptyBillingAddress();

	states:string[] =
	[
		'Aguascalientes','Baja California','Baja California Sur','Campeche','Chiapas','Chihuahua',
		'Ciudad de México','Coahuila','Colima','Durango','Guanajuato','Guerrero','Hidalgo','Jalisco',
		'México','Michoacán','Morelos','Nayarit','Nuevo León','Oaxaca','Puebla','Querétaro',
		'Quintana Roo','San Luis Potosí','Sinaloa','Sonora','Tabasco','Tamaulipas','Tlaxcala',
		'Veracruz','Yucatán','Zacatecas'
	];

	sat_regimen_fiscal_list:{code:string,name:string}[] =
	[
		{code:'601',name:'General de Ley Personas Morales'},
		{code:'602',name:'Regimen Simplificado de Ley Personas Morales'},
		{code:'603',name:'Personas Morales con Fines no Lucrativos'},
		{code:'604',name:'Régimen de pequeños contribuyentes'},
		{code:'605',name:'Sueldos y Salarios e Ingresos Asimilados a Salarios'},
		{code:'606',name:'Arrendamiento'},
		{code:'607',name:'Régimen de Enajenación o Adquisición de Bienes'},
		{code:'608',name:'Demás ingresos'},
		{code:'609',name:'Consolidación'},
		{code:'610',name:'Residentes en el Extranjero sin Establecimiento Permanente en México'},
		{code:'611',name:'Ingresos por Dividendos (socios y accionistas)'},
		{code:'612',name:'Personas Físicas con Actividades Empresariales y Profesionales'},
		{code:'613',name:'Ingresos por Enajenación de Bienes'},
		{code:'614',name:'Ingresos por intereses'},
		{code:'615',name:'Régimen de los ingresos por obtención de premios'},
		{code:'616',name:'Sin obligaciones fiscales'},
		{code:'617',name:'PEMEX'},
		{code:'618',name:'Régimen Simplificado de Ley Personas Físicas'},
		{code:'619',name:'Ingresos por la Obtención de Préstamos'},
		{code:'620',name:'Sociedades Cooperativas de Producción que optan por diferir sus ingresos'},
		{code:'621',name:'Incorporación Fiscal'},
		{code:'622',name:'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras'},
		{code:'623',name:'Opcional para Grupos de Sociedades'},
		{code:'624',name:'Coordinados'},
		{code:'625',name:'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas'},
		{code:'626',name:'Régimen Simplificado de Confianza'},
		{code:'628',name:'Hidrocarburos'},
		{code:'629',name:'De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales'},
		{code:'630',name:'Enajenación de acciones en bolsa de valores'}
	];

	getEmptyBillingAddress():Address
	{
		let address = GetEmpty.address();
		address.type = 'BILLING';
		address.status = 'ACTIVE';
		return address;
	}

	ngOnInit()
	{
		this.subs.sink = this.route.paramMap.subscribe( params =>
		{
			this.is_loading = true;
			let defaultUser:Partial<User> = {
				name: '',
				code: '',
				email: '',
				phone: '',
				status: 'ACTIVE',
				store_id: undefined,
				type:'USER',
				credit_days: 0,
				credit_limit: 0,
				price_type_id: undefined,
			};

			let user_permission = GetEmpty.user_permission();
			user_permission.is_provider = 1;

			this.subs.sink = forkJoin({
				user: params.has('id') ? this.rest.user.get(params.get('id')) : of(defaultUser),
				stores: this.rest.store.search({limit:99999,sort_order:['name_ASC']}),
				user_permission: params.has('id') ? this.rest.user_permission.get( params.get('id') ) : of( user_permission ),
				address: params.has('id')
					? this.rest.address.search({limit:1, eq:{ user_id: parseInt( params.get('id') ), type:'BILLING', status:'ACTIVE' }})
					: of({data:[] as Address[], total:0}),

			}).subscribe((response)=>
			{
				if( response.user_permission.is_provider )
				{
					this.is_loading = false;
					this.user		= response.user;
					this.store_list	= response.stores.data;
					this.user_permission = response.user_permission;
					this.address	= response.address.data.length
						? response.address.data[0]
						: this.getEmptyBillingAddress();
				}
				else
				{
					this.user = {type:'USER',name:'',credit_days: 0, credit_limit: 0, status:'ACTIVE'};
					this.showError('NO se encontrol el proveedor');
				}
			});
		});
	}

	hasBillingData():boolean
	{
		return !!( this.address.rfc || this.address.name || this.address.address
			|| this.address.zipcode || this.address.city || this.address.state
			|| this.address.suburb || this.address.sat_regimen_fiscal );
	}

	saveAddress(user_id:number):Observable<any>
	{
		if( !this.address.id && !this.hasBillingData() )
			return of( null );

		this.address.user_id = user_id;
		this.address.type = 'BILLING';
		this.address.status = 'ACTIVE';

		if( this.address.rfc )
			this.address.rfc = this.address.rfc.trim().toUpperCase();

		if( !this.address.name )
			this.address.name = this.user.name;

		return this.address.id
			? this.rest.address.update( this.address )
			: this.rest.address.create( this.address );
	}

	save()
	{
		this.is_loading = true;

		if( this.user.id	)
		{
			this.user.username = this.user.name;
			this.subs.sink	= this.rest.user.update( this.user )
			.pipe( mergeMap((response)=> this.saveAddress( response.id )) )
			.subscribe((_response)=>
			{
				this.is_loading = false;
				this.location.back();
				this.showSuccess('El usuario se actualizó exitosamente');
			},(error)=>this.showError(error));
		}
		else
		{
			this.user.username = this.user.email || this.user.name;
			this.subs.sink	= this.rest.user
			.create( this.user ).pipe
			(
				mergeMap((response)=>
				{
					this.showSuccess('El Usuario se guardó exitosamente');
					this.user_permission.user_id = response.id;
					this.user_permission.is_provider = 1;
					return forkJoin
					({
						user_permission: this.rest.user_permission.update( this.user_permission ),
						address: this.saveAddress( response.id )
					});
				})
			)
			.subscribe((_user)=>
			{
				this.showSuccess('El usuario se asigno el rol de proveedor exitosamente');
				this.is_loading = false;
				this.location.back();
			},(error)=>this.showError(error));
		}
	}
}
